import { defaultContext } from '../context/context';
import { useCallback, useState } from 'react';

const useDevToolsContext = () => {
  const [isOpen, setIsOpen] = useState(defaultContext.isOpen);
  const [menu, localSetMenu] = useState(defaultContext.menu);

  const setMenu = useCallback((position, id, payload) => {
    localSetMenu((currentValue) => {
      const copy = currentValue.slice(0, position);

      copy.push({ id, payload });

      return copy;
    });
  }, []);

  const back = useCallback((index) => {
    console.log(index);

    localSetMenu((currentValue) => {
      const copy = [];

      for (let i = 0; i < index; i++) {
        copy.push(currentValue[i]);
      }

      return copy;
    });
  }, []);

  return {
    isOpen,
    setIsOpen,
    menu,
    setMenu,
    back,
  };
};

export default useDevToolsContext;
